module.exports = __webpack_public_path__ + "youhui2.png?644371d0a18ff4974428057eed1e69ea";


//////////////////
// WEBPACK FOOTER
// ./static/assets/youhui2.png
// module id = 187
// module chunks = 0